import { render, staticRenderFns } from "./EquityRelease.vue?vue&type=template&id=32a8b436"
import script from "./EquityRelease.vue?vue&type=script&lang=js"
export * from "./EquityRelease.vue?vue&type=script&lang=js"
import style0 from "./EquityRelease.vue?vue&type=style&index=0&id=32a8b436&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports